import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const CircleSolidIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path fill="currentColor" d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11" />
  </BaseIcon>
)
